import { __awaiter } from "tslib";
import { showNotification } from '@genesislcap/foundation-notifications';
import { logger } from '../utils';
export const createFormData = (files) => {
    const formData = new FormData();
    files.forEach((file) => {
        formData.append(file.name, file);
    });
    return formData;
};
export const uploadFiles = (url, formData, authToken) => {
    const headers = new Headers();
    headers.append('SESSION_AUTH_TOKEN', authToken);
    return fetch(url, {
        method: 'POST',
        body: formData,
        headers,
    }).then((response) => response.json().then((data) => {
        return data;
    }));
};
export const downloadFile = (url, filename, authToken, method = 'GET', showNotifications, body) => {
    const headers = new Headers();
    headers.append('SESSION_AUTH_TOKEN', authToken);
    fetch(url, {
        method,
        body,
        headers,
    })
        .then((res) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (res.ok) {
            return res.blob();
        }
        else {
            const error = yield res.json();
            showNotifications
                ? showNotification({
                    title: error === null || error === void 0 ? void 0 : error.MESSAGE_TYPE,
                    body: (_a = error === null || error === void 0 ? void 0 : error.DETAILS) === null || _a === void 0 ? void 0 : _a.ERROR,
                    config: { toast: { autoClose: true, closeTimeout: 5000, type: 'warning' } },
                }, 'zero')
                : '';
            logger.error(error || 'An error occurred while downloading the file.');
        }
    }))
        .then((blob) => {
        if (blob) {
            const objectUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = objectUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            showNotifications
                ? showNotification({
                    title: 'Success',
                    body: 'File downloaded successfully',
                    config: { toast: { autoClose: true, closeTimeout: 5000, type: 'success' } },
                }, 'zero')
                : '';
            logger.info('File downloaded successfully');
        }
    })
        .catch((error) => {
        logger.error(error);
    });
};
